const EventService = {
  on(event, callback) {
    window.addEventListener(event, callback);
  },
  remove(event, callback) {
    window.removeEventListener(event, callback, false);
  },
};

export default EventService;
